// Bilingual profile copy, based on the user-supplied CVs.
const en = {
  "showreel": {
    "nineQuality": "1440p · 60 FPS · gameplay + music",
    "masterCapture": "Download original 1440p capture",
    "nineLives": "New flagship · 6 × 5 collector cascades · nine free spins · carried multiplier",
    "club": "Hold & Spin, persistent coins and full-column boosters. Go server with a RabbitMQ-backed math worker.",
    "eyebrow": "PERSONAL PROJECT / REAL GAMEPLAY",
    "title": "Game engines you can see in action",
    "intro": "Five TGSlots prototypes, led by Nine Lives. Real gameplay captured from the running PixiJS clients and local backends. Promo edits use licensed music without game sound effects.",
    "reel": "TGSlots · Gameplay reel",
    "promo": "Promo edit",
    "linkedin": "Download LinkedIn edit · 4:5",
    "music": "Promo music:",
    "musicEdits": "Edited music excerpts. No game sound effects.",
    "gameplay": "Full capture",
    "source": "Explore the source",
    "note": "Personal prototypes with demo credits. These recordings show my public game platform; commercial backend work is listed below.",
    "choose": "Choose a game video",
    "format": "Choose video format",
    "fallback": "Your browser cannot play this video. Download the MP4.",
    "dragon": "5 × 3 reels · 25 paylines · free-spin engine",
    "woodland": "5 × 3 reels · 30 paylines · pick bonus · ×2 free spins",
    "militare": "6 × 5 grid · combat cascades · persistent giant WILDs",
    "reelDescription": "Five games. One shared platform. A short edit of real captured gameplay.",
    "failure": "Video could not load. Open the MP4 directly."
  },
  "nav": {
    "home": "Home",
    "projects": "Projects",
    "experience": "Experience",
    "skills": "Skills",
    "github": "GitHub",
    "contact": "Contact",
    "design": "Design",
    "games": "Games"
  },
  "hero": {
    "greeting": "5+ years of commercial engineering",
    "name": "Terentiy Gatsukov",
    "role": "Senior C# / .NET Backend Developer",
    "tagline": "I build systems where money, state and performance matter: game platforms, marketplace SaaS and equipment integrations.",
    "cta": "Explore my experience",
    "contact": "Get in touch",
    "downloadCv": "Slot Games CV · EN",
    "location": "Minsk, Belarus · Remote · Open to relocation",
    "backendCv": "Backend CV · RU",
    "metricsTitle": "Commercial engineering outcomes",
    "rps": "concurrent bet processing / RPS",
    "speedup": "faster engine calculations",
    "games": "game backends to production",
    "library": "titles using the shared library",
    "metricsContext": "Custom Games Studio · November 2023 — July 2026"
  },
  "about": {
    "title": "From transaction integrity to game mathematics",
    "intro": "My commercial work spans gaming and entertainment, e-commerce, transportation and IoT. I focus on distributed systems, financial correctness, resilience and performance, with frontend delivery experience.",
    "customGames": "C# / F#: probability monads, trampolines, unbiased RNG, the alias method and segment trees. 1B+ spin simulations, RTP, volatility, confidence intervals and reproducible replay.",
    "tgslotsLive": "704 core tests in Slot Math Lab; 812 tests in TGSlots. Both are personal projects, with prototype limits documented in their READMEs.",
    "fullstack": "Event-driven architecture, CQRS, Outbox/Inbox and idempotency. Concurrent operations, distributed coordination, conditional updates and external-system integrations.",
    "philosophy": "I optimize memory and latency, use Roslyn generators and build observability. Claude, Cursor and Copilot assist implementation, refactoring and tests; architecture, verification and final review remain my responsibility.",
    "tgslotsCta": "Explore Slot Math Lab ↗",
    "eyebrow": "ENGINEERING FOCUS",
    "backendTitle": "Systems under load",
    "gameTitle": "Mathematics and game engines",
    "practiceTitle": "Verification and tooling"
  },
  "design": {
    "title": "Design System v1.0",
    "heading": "TERMINAL CASINO",
    "subtitle": "A neon-lit engineering dashboard. CRT terminal meets slot machine internals. Built for someone who sees the code behind the show.",
    "colorPalette": "Color Palette",
    "primaryBg": "Primary bg",
    "secondaryBg": "Secondary bg",
    "tertiaryBg": "Tertiary bg",
    "elevatedBg": "Elevated bg",
    "terminalGreen": "Terminal Green",
    "jackpotAmber": "Jackpot Amber",
    "cherryRed": "Cherry Red",
    "gold": "Gold",
    "crtBlue": "CRT Blue",
    "typography": "Typography",
    "typeDisplay": "Display: Orbitron 900",
    "typeHeadings": "Headings: Saira 600",
    "typeBody": "Body: JetBrains Mono",
    "motion": "Motion",
    "surfacePrimitives": "Surface Primitives",
    "spacingScale": "Spacing Scale",
    "liveData": "Live Data (API)",
    "rngCertified": "RNG CERTIFIED",
    "rngDesc": "HMAC-SHA256 with client seed commitment. Provably fair — every spin is independently verifiable.",
    "paylineEngine": "PAYLINE ENGINE",
    "paylineDesc": "Trie-based evaluator scoring 20 paylines in O(k) time. Walker's Alias Method for O(1) weighted symbol selection.",
    "swatchPrimaryBg": "Primary bg",
    "swatchSecondaryBg": "Secondary bg",
    "swatchTertiaryBg": "Tertiary bg",
    "swatchElevatedBg": "Elevated bg",
    "swatchTerminalGreen": "Terminal Green",
    "swatchJackpotAmber": "Jackpot Amber",
    "swatchCherryRed": "Cherry Red",
    "swatchGold": "Gold",
    "swatchCrtBlue": "CRT Blue",
    "typeDisplay5xl": "display / 5xl",
    "typeHeading3xl": "heading / 3xl",
    "typeHeadingXl": "heading / xl",
    "typeBodyBase": "body / base",
    "typeMonoSm": "mono / sm",
    "typeJackpot": "JACKPOT",
    "typeHeadingSample": "Slot Engine Architecture",
    "typeHeadingSmallSample": "HMAC-SHA256 Provably Fair RNG",
    "typeBodySample": "The spin endpoint computes reel positions using a cryptographic hash chain. Each outcome is verifiable by the player — the server commits to a server seed before the client provides their seed, ensuring neither party can manipulate the result.",
    "typeMonoSample": "POST /api/v1/slots/spin  →  { outcome, proof, payout }",
    "motionNeonPulse": "Neon Pulse",
    "motionSlotSpin": "Slot Spin",
    "motionStaggered": "Staggered Reveal",
    "motionGlowHover": "Glow on Hover",
    "projectsLabel": "PROJECTS",
    "experienceLabel": "EXPERIENCE",
    "skillsLabel": "SKILLS",
    "githubLabel": "GITHUB"
  },
  "projects": {
    "filterBy": "Filter by technology",
    "all": "All",
    "filterByDomain": "Filter by domain",
    "allDomains": "All",
    "domainIGaming": "iGaming",
    "domainCrypto": "Crypto",
    "domainRealTime": "Real-Time",
    "domainFullstack": "Fullstack",
    "statusLive": "Live",
    "statusPersonal": "Personal",
    "statusWorkNda": "NDA",
    "statusOpenSource": "Open Source",
    "playLive": "Play it live ↗",
    "tgslotsEmbedTitle": "TGSlots — Live Demo",
    "tgslotsFallback": "TGSlots is a social-casino Telegram Mini App. The embed may be blocked by your browser. Open it directly.",
    "embedBlocked": "Embed blocked by browser security policy.",
    "intro": "Personal engineering projects: public source, architecture decisions and recorded verification. They complement my commercial work; prototype boundaries are documented in each README.",
    "previewCaption": "JobFinder · revision-conflict acceptance preserving an unsaved draft",
    "source": "Source",
    "evidence": "Evidence",
    "live": "Live",
    "noMatch": "No projects match these filters.",
    "domainWorkflow": "Durable workflows",
    "domainBIM": "BIM / CAD",
    "personalRole": "Personal engineering project",
    "eyebrow": "PUBLIC ENGINEERING WORK"
  },
  "contact": {
    "info": "Open to opportunities in .NET backend, distributed systems and game engineering. Reach me by email or Telegram.",
    "formLabel": "Contact form",
    "nameLabel": "Name",
    "emailLabel": "Email",
    "messageLabel": "Message",
    "send": "Send Message",
    "sending": "Sending...",
    "success": "Message sent! I'll get back to you soon.",
    "error": "Something went wrong. Please try again."
  },
  "footer": {
    "name": "Terentiy Gatsukov",
    "role": "Senior .NET Backend Developer",
    "specialty": "Gaming · E-commerce · Transportation · IoT",
    "builtWith": "Commercial experience from the current CVs. Personal project source and verification on GitHub."
  },
  "theme": {
    "light": "☀ Light",
    "dark": "☾ Dark"
  },
  "a11y": {
    "skipToContent": "Skip to main content"
  },
  "common": {
    "loading": "Loading",
    "error": "ERROR",
    "noData": "No data available.",
    "present": "Present"
  },
  "experience": {
    "eyebrow": "COMMERCIAL EXPERIENCE"
  },
  "games": {
    "title": "Games I built backends for",
    "intro": "My role: full game backend. These Konami Gaming video demonstrations are linked in the English Slot Games CV.",
    "video": "View demonstration",
    "mechanics": "Mechanics: Super Respin, Hold & Spin, Wheel Bonus, jackpots, progressives, free spins, cascades, Megaways, Cluster, Nudge, wilds and collection features."
  },
  "education": {
    "title": "Education and working context",
    "degree": "Engineering degree",
    "university": "BSUIR · Faculty of Computer-Aided Design · Minsk",
    "specialty": "Design and Production of Software-Controlled Electronic Devices.",
    "languagesTitle": "LANGUAGES / WORKING ARRANGEMENTS",
    "languages": "Russian — native · English — B1",
    "location": "Based in Minsk, Belarus. Remote work; open to relocation and business travel.",
    "authorization": "Work authorization: Armenia, Belarus, Georgia, Kazakhstan, Russia and Uzbekistan."
  }
};

const ru: typeof en = {
  "showreel": {
    "nineQuality": "1440p · 60 FPS · геймплей + музыка",
    "masterCapture": "Скачать оригинал записи 1440p",
    "nineLives": "Новый флагман · каскады 6 × 5 · сбор фишек · девять фриспинов · накопительный множитель",
    "club": "Hold & Spin, закреплённые монеты и бустеры заполненных колонок. Go-сервер и математический worker через RabbitMQ.",
    "eyebrow": "ЛИЧНЫЙ ПРОЕКТ / РЕАЛЬНЫЙ ГЕЙМПЛЕЙ",
    "title": "Игровые движки в действии",
    "intro": "Пять игровых прототипов TGSlots во главе с Nine Lives. Реальный геймплей работающих PixiJS-клиентов и локальных backend. В промо — лицензированная музыка без игровых звуков.",
    "reel": "TGSlots · Игровой шоурил",
    "promo": "Промо-монтаж",
    "linkedin": "Скачать для LinkedIn · 4:5",
    "music": "Музыка промо:",
    "musicEdits": "Смонтированные музыкальные фрагменты. Без игровых звуков.",
    "gameplay": "Полная запись",
    "source": "Посмотреть исходники",
    "note": "Личные прототипы с демо-кредитами. Здесь — моя публичная игровая платформа; коммерческий backend-опыт представлен ниже.",
    "choose": "Выбрать видео игры",
    "format": "Выбрать формат видео",
    "fallback": "Браузер не воспроизводит видео. Скачать MP4.",
    "dragon": "Барабаны 5 × 3 · 25 линий · движок фриспинов",
    "woodland": "Барабаны 5 × 3 · 30 линий · pick-бонус · фриспины ×2",
    "militare": "Поле 6 × 5 · боевые каскады · закреплённые гигантские WILD",
    "reelDescription": "Пять игр. Одна общая платформа. Короткий монтаж реального геймплея.",
    "failure": "Видео не загрузилось. Открыть MP4 напрямую."
  },
  "nav": {
    "home": "Главная",
    "projects": "Проекты",
    "experience": "Опыт",
    "skills": "Навыки",
    "github": "GitHub",
    "contact": "Контакты",
    "design": "Дизайн",
    "games": "Игры"
  },
  "hero": {
    "greeting": "5+ лет коммерческого опыта",
    "name": "Терентий Гацуков",
    "role": "Senior C# / .NET Backend Developer",
    "tagline": "Проектирую системы, в которых важны деньги, состояние и производительность: игровые платформы, e-commerce и интеграции оборудования.",
    "cta": "Коммерческий опыт",
    "contact": "Связаться",
    "downloadCv": "Slot Games CV · EN",
    "location": "Минск · Удалённо · Готов к переезду",
    "backendCv": "Backend CV · RU",
    "metricsTitle": "Результаты коммерческой работы",
    "rps": "конкурентные ставки / RPS",
    "speedup": "ускорение расчётов",
    "games": "бэкендов игр до production",
    "library": "тайтлов на общей библиотеке",
    "metricsContext": "Custom Games Studio · ноябрь 2023 — июль 2026"
  },
  "about": {
    "title": "От целостности данных до игровой математики",
    "intro": "Мой коммерческий опыт — Gaming & Entertainment, E-commerce, Transportation Tech и IoT. Работаю с распределёнными системами, финансовой корректностью, отказоустойчивостью и производительностью. Есть опыт frontend-разработки.",
    "customGames": "C# / F#: монады вероятностей, trampolines, unbiased RNG, alias method и segment trees. Симуляции 1B+ вращений, RTP, волатильность, доверительные интервалы и воспроизводимый replay.",
    "tgslotsLive": "704 core-теста в Slot Math Lab; 812 тестов в TGSlots. Это личные проекты; ограничения прототипов описаны в README.",
    "fullstack": "Event-driven архитектура, CQRS, Outbox/Inbox и идемпотентность. Конкурентные операции, распределённые блокировки, условные обновления и интеграции с внешними системами.",
    "philosophy": "Оптимизирую память и задержки, использую Roslyn-генераторы и наблюдаемость. Claude, Cursor и Copilot помогают в реализации, рефакторинге и тестах; архитектура, проверка и финальное ревью остаются моей ответственностью.",
    "tgslotsCta": "Посмотреть Slot Math Lab ↗",
    "eyebrow": "ИНЖЕНЕРНЫЙ ФОКУС",
    "backendTitle": "Системы под нагрузкой",
    "gameTitle": "Математика и игровые движки",
    "practiceTitle": "Проверка и инструменты"
  },
  "design": {
    "title": "Design System v1.0",
    "heading": "TERMINAL CASINO",
    "subtitle": "Неоновая инженерная панель. CRT-терминал встречает внутренности игрового автомата. Для тех, кто видит код за шоу.",
    "colorPalette": "Цветовая палитра",
    "primaryBg": "Основной фон",
    "secondaryBg": "Вторичный фон",
    "tertiaryBg": "Третичный фон",
    "elevatedBg": "Приподнятый фон",
    "terminalGreen": "Терминальный зелёный",
    "jackpotAmber": "Янтарный джекпот",
    "cherryRed": "Вишнёвый красный",
    "gold": "Золотой",
    "crtBlue": "CRT синий",
    "typography": "Типографика",
    "typeDisplay": "Display: Orbitron 900",
    "typeHeadings": "Заголовки: Saira 600",
    "typeBody": "Текст: JetBrains Mono",
    "motion": "Движение",
    "surfacePrimitives": "Примитивы поверхности",
    "spacingScale": "Шкала отступов",
    "liveData": "Live Data (API)",
    "rngCertified": "RNG СЕРТИФИЦИРОВАН",
    "rngDesc": "HMAC-SHA256 с фиксацией клиентского сида. Абсолютная честность — каждое вращение независимо проверяемо.",
    "paylineEngine": "ДВИЖОК ВЫПЛАТ",
    "paylineDesc": "Оценщик на основе Trie, обрабатывающий 20 линий выплат за O(k). Метод алиасов Уокера для O(1) взвешенного выбора символов.",
    "swatchPrimaryBg": "Основной фон",
    "swatchSecondaryBg": "Вторичный фон",
    "swatchTertiaryBg": "Третичный фон",
    "swatchElevatedBg": "Приподнятый фон",
    "swatchTerminalGreen": "Терминальный зелёный",
    "swatchJackpotAmber": "Янтарный джекпот",
    "swatchCherryRed": "Вишнёвый красный",
    "swatchGold": "Золотой",
    "swatchCrtBlue": "CRT синий",
    "typeDisplay5xl": "display / 5xl",
    "typeHeading3xl": "heading / 3xl",
    "typeHeadingXl": "heading / xl",
    "typeBodyBase": "body / base",
    "typeMonoSm": "mono / sm",
    "typeJackpot": "ДЖЕКПОТ",
    "typeHeadingSample": "Архитектура слотового движка",
    "typeHeadingSmallSample": "HMAC-SHA256 доказуемо честный ГСЧ",
    "typeBodySample": "Эндпоинт вращения вычисляет позиции барабанов с использованием криптографической хеш-цепочки. Каждый результат проверяем игроком — сервер фиксирует серверный сид до того, как клиент предоставит свой, гарантируя, что ни одна сторона не может манипулировать результатом.",
    "typeMonoSample": "POST /api/v1/slots/spin  →  { outcome, proof, payout }",
    "motionNeonPulse": "Неоновая пульсация",
    "motionSlotSpin": "Вращение слота",
    "motionStaggered": "Последовательное появление",
    "motionGlowHover": "Свечение при наведении",
    "projectsLabel": "ПРОЕКТЫ",
    "experienceLabel": "ОПЫТ",
    "skillsLabel": "НАВЫКИ",
    "githubLabel": "GITHUB"
  },
  "projects": {
    "filterBy": "Фильтр по технологии",
    "all": "Все",
    "filterByDomain": "Фильтр по домену",
    "allDomains": "Все",
    "domainIGaming": "iGaming",
    "domainCrypto": "Крипто",
    "domainRealTime": "Real-Time",
    "domainFullstack": "Fullstack",
    "statusLive": "Live",
    "statusPersonal": "Личное",
    "statusWorkNda": "NDA",
    "statusOpenSource": "Open Source",
    "playLive": "Играть ↗",
    "tgslotsEmbedTitle": "TGSlots — Live Демо",
    "tgslotsFallback": "TGSlots — social-casino Telegram Mini App. Возможно, встраивание заблокировано вашим браузером. Откройте напрямую.",
    "embedBlocked": "Встраивание заблокировано политикой безопасности браузера.",
    "intro": "Личные инженерные проекты: открытый код, архитектурные решения и результаты проверок. Они дополняют коммерческий опыт; ограничения прототипов описаны в README.",
    "previewCaption": "JobFinder · проверка конфликта версий с сохранением несохранённого черновика",
    "source": "Код",
    "evidence": "Проверки",
    "live": "Демо",
    "noMatch": "Нет проектов с выбранными фильтрами.",
    "domainWorkflow": "Workflows",
    "domainBIM": "BIM / CAD",
    "personalRole": "Личный инженерный проект",
    "eyebrow": "ПУБЛИЧНЫЕ ИНЖЕНЕРНЫЕ ПРОЕКТЫ"
  },
  "contact": {
    "info": "Открыт к предложениям по .NET backend, распределённым системам и игровой инженерии. Напишите на email или в Telegram.",
    "formLabel": "Форма обратной связи",
    "nameLabel": "Имя",
    "emailLabel": "Email",
    "messageLabel": "Сообщение",
    "send": "Отправить",
    "sending": "Отправка...",
    "success": "Сообщение отправлено! Я свяжусь с вами в ближайшее время.",
    "error": "Что-то пошло не так. Попробуйте ещё раз."
  },
  "footer": {
    "name": "Терентий Гацуков",
    "role": "Senior .NET Backend Developer",
    "specialty": "Gaming · E-commerce · Transportation · IoT",
    "builtWith": "Коммерческий опыт — из актуальных CV. Код и проверки личных проектов — на GitHub."
  },
  "theme": {
    "light": "☀ Светлая",
    "dark": "☾ Тёмная"
  },
  "a11y": {
    "skipToContent": "Перейти к содержимому"
  },
  "common": {
    "loading": "Загрузка",
    "error": "ОШИБКА",
    "noData": "Нет данных.",
    "present": "По настоящее время"
  },
  "experience": {
    "eyebrow": "КОММЕРЧЕСКИЙ ОПЫТ"
  },
  "games": {
    "title": "Игры, для которых я создавал backend",
    "intro": "Моя роль — полный backend игры. Ссылки на видеодемонстрации Konami Gaming приведены в английском Slot Games CV.",
    "video": "Смотреть демонстрацию",
    "mechanics": "Механики: Super Respin, Hold & Spin, Wheel Bonus, jackpots, progressives, free spins, cascades, Megaways, Cluster, Nudge, wilds и collection features."
  },
  "education": {
    "title": "Образование и рабочий контекст",
    "degree": "Инженерное образование",
    "university": "БГУИР · Факультет компьютерного проектирования · Минск",
    "specialty": "Проектирование и производство программно-управляемых электронных средств.",
    "languagesTitle": "ЯЗЫКИ / ФОРМАТ РАБОТЫ",
    "languages": "Русский — родной · Английский — B1",
    "location": "Минск, Беларусь. Удалённая работа; готов к переезду и командировкам.",
    "authorization": "Разрешение на работу: Армения, Беларусь, Грузия, Казахстан, Россия, Узбекистан."
  }
};

export { en, ru };
